import VisualizarCompraModal from './VisualizarCompraModal';

export default VisualizarCompraModal;
